export const salesReportsAccionesRoles = {
  sideNavActions: {
    salesReportsWorkbook: ['Admin', 'SalesRepresentative', 'PowerBiWsSales'],
  },
};
